export default __webpack_public_path__ + "static/media/1.833ea723.png";